import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { translations } from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sts_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sts_lang") || "en");
  const [owner, setOwner] = useState(null);
  const [bootLoading, setBootLoading] = useState(true);

  const t = translations[lang];

  const toggleLang = useCallback(() => {
    setLang((l) => {
      const next = l === "en" ? "hi" : "en";
      localStorage.setItem("sts_lang", next);
      return next;
    });
  }, []);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem("sts_token");
    if (!token) {
      setOwner(null);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setOwner(r.data);
    } catch {
      localStorage.removeItem("sts_token");
      setOwner(null);
    }
  }, []);

  useEffect(() => {
    refreshMe().finally(() => setBootLoading(false));
  }, [refreshMe]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("sts_token", r.data.token);
    setOwner(r.data.owner);
    return r.data.owner;
  };

  const signup = async (payload) => {
    const r = await api.post("/auth/signup", payload);
    localStorage.setItem("sts_token", r.data.token);
    setOwner(r.data.owner);
    return r.data.owner;
  };

  const logout = () => {
    localStorage.removeItem("sts_token");
    setOwner(null);
  };

  return (
    <AppCtx.Provider value={{ lang, t, toggleLang, owner, setOwner, login, signup, logout, refreshMe, bootLoading }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useApp = () => useContext(AppCtx);
